const populateSwatchesTable = async () => {
  const data = await getCollectionByName();
  tableData = data;
  console.log(data)
  const swatchesTableBody = document.getElementById("swatch-bodycontainer");

  const tableBody = data
    .map((ele, i) => {
      return `
   <div class="col-lg-4 col-md-6 col-12 mb-2">
    <div class="box">
        <div style="text-align: center">
           <button class="btn btn-secondary" onclick="viewLabel(${i})">View Label</button>
        </div>
        <div class="box-content" style="" id="swatches${i}">
            <div class="info-section">
                <div>
                    <span><b>First Name:</b> ${ele.first_name}</span>
                </div>
                <div>
                    <span><b>Last Name:</b> ${ele.last_name}</span>
                </div>
                <div>
                    <span><b>Email:</b> ${ele.email}</span>
                </div>
                <div>
                    <span><b>Phone:</b> ${ele.phone}</span>
                </div>
                <div>
                    <span><b>Swatches Value:</b></span>
                    <div class="swatch-content">${ele.swatchesValue}</div>
                </div>
                <div>
                    <span><b>Address:</b> ${ele.address}</span>
                </div>
                <div>
                    <span><b>Address 2:</b> ${ele.address2}</span>
                </div>
                <div>
                    <span><b>Town:</b> ${ele.town}</span>
                </div>
                <div>
                    <span><b>Postcode:</b> ${ele.postcode}</span>
                </div>
                ${
                  ele?.date
                    ? `
                <div>
                    <span><b>Date:</b> ${ele.date}</span>
                </div>`
                    : ""
                }
            </div>
        </div>
        <div style="text-align: center">
            <button class="btn btn-primary" onclick="downloadLabel('${i}','${
        ele.first_name
      }')">Download</button>
            <button class="btn btn-danger" style="background-color:red" onclick="deleteSwatches('${
              ele.id
            }')">Delete</button>
        </div>
    </div>
</div>
`;
    })
    .join("");

  if (swatchesTableBody) {
    swatchesTableBody.innerHTML =
      tableBody ||
      `<h5 style="text-align:center;margin:10px;">No swatches orders details found</h5>`;
  }
};

const generateLabel = (orderDetails, printable, index) => {
  return `
      <div class="label-container ${printable ? "label-size" : ""} 
      ${index > 0 && "margin-label"}">
      <div class="label-header row">
        <div class="col text-right label-logo">
          <img src="${base64logo}" alt="Sleep Village Logo" />
        </div>
      </div>
      <div style="display: flex; height: 100%; align-items: flex-start;">
        <div class="label-content">
          <p>
            <strong>${orderDetails?.title || "Mr"}  
            ${orderDetails.first_name} ${orderDetails.last_name}</strong> 
          </p>
          <p>${orderDetails.address}</p>
          ${orderDetails.address2 && `<p>${orderDetails.address}</p>`}
          <p>${orderDetails.town}</p>
          <p>${orderDetails.postcode}</p>
        </div>
      </div>
      <div class="label-swatch">
        <p>
          <strong style="text-wrap: nowrap">Swatch Color : </strong>
          ${orderDetails.swatchesValue
            .split(",")
            .map((ele) => ele.replace(" ", "-"))
            .join(" , ")}
        </p>
      </div>
    </div>
  `;
};
const arrangeData = async () => {
  var users = await getCollectionByName(); // Assuming getCollectionByName() retrieves user data
  formata = [];
  function formatSwatches(swatches) {
    return swatches.replaceAll("+", " ");
  }

  users.forEach(function (user) {
    var swatches = formatSwatches(user.swatchesValue);
    formata.push({
      "First Name": user.first_name,
      "Last Name": user.last_name,
      Email: user.email,
      Phone: user.phone,
      Address: user.address,
      Address2: user.address2,
      Town: user.town,
      Postcode: user.postcode,
      "Swatches Value": swatches,
    });
  });

  return formata;
};

const exportToExcel = async () => {
  debugger;
  const data = await arrangeData();
  var wb = XLSX.utils.book_new();
  var ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  saveAs(
    new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
    "ordered-swatches.xlsx"
  );
};

const viewLabel = (index) => {
  const order = tableData[index];
  const element = generateLabel(order);
  const modalBodyContent = document.getElementById("modalBodyContent");

  if (element && modalBodyContent) {
    modalBodyContent.innerHTML = element;
    const swatchModalElement = document.getElementById("swatchModal");
    swatchModalInstance = new bootstrap.Modal(swatchModalElement);
    swatchModalInstance.show();
  }
};

const hideModal = () => {
  if (swatchModalInstance) {
    swatchModalInstance.hide();
  }
};

const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const printElement = (element, filename) => {
  if (typeof html2pdf !== "undefined") {
    // Configuration for the pdf
    const options = {
      margin: 0.1,
      filename,
      html2canvas: { scale: 8 },
      jsPDF: { unit: "in", format: "a6", orientation: "portrait" },
    };

    // Convert the HTML element to a PDF
    html2pdf().from(element).set(options).save();
  } else {
    console.error("html2pdf library is not loaded.");
  }
};

const downloadLabel = (index, name) => {
  const element = generateLabel(tableData[index], true);
  const date = getCurrentDate();
  const filename = name + "-" + date + "-swatches";
  printElement(element, filename);
};

const downloadAllLabels = () => {
  const element = tableData
    .map((table, i) => generateLabel(table, true, i))
    .join("");
  printElement(element, "swatches label");
};

const deleteAllSwatchOrders = async () => {
  if (tableData.length == 0) {
    return alert("No data to delete");
  }
  const userConfirmed = confirm("Are you sure you want to delete all items?");
  if (!userConfirmed) {
    return;
  }
  try {
    $("#loading-container").css("display", "flex");
    const querySnapshot = await db.collection("swatches").get();

    // Create an array of delete promises
    const deletePromises = querySnapshot.docs.map((doc) =>
      db.collection("swatches").doc(doc.id).delete()
    );

    // Wait for all delete operations to complete
    await Promise.all(deletePromises);
    await populateSwatchesTable();

    alert("All Swatches order deleted successfully");
    $("#loading-container").css("display", "none");
  } catch (error) {
    console.log(error);
    alert("Error in deleting data");
    $("#loading-container").css("display", "none");
  }
};

const deleteSwatches = async (id) => {
  const userConfirmed = confirm("Are you sure you want to delete this item?");
  if (!userConfirmed) {
    return; // Exit the function if the user cancels
  }
  try {
    $("#loading-container").css("display", "flex");
    await db.collection("swatches").doc(id).delete();
    await populateSwatchesTable();
    alert("Deleted successfully");
    $("#loading-container").css("display", "none");
  } catch (error) {
    console.log(error);
    alert("Error in deleting data");
    $("#loading-container").css("display", "none");
  }
};

$(window).on("load", function () {
  populateSwatchesTable();
});
